import { render, staticRenderFns } from "./open-source-acknowledgement.vue?vue&type=template&id=eda00ec4&"
import script from "./open-source-acknowledgement.vue?vue&type=script&lang=js&"
export * from "./open-source-acknowledgement.vue?vue&type=script&lang=js&"
import style0 from "./open-source-acknowledgement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports